module.exports = __webpack_public_path__ + "static/media/bookmark.c6131523.svg";